import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";

@Component({
  selector: 'app-select-year-and-month',
  templateUrl: './select-year-and-month.component.html',
  styleUrls: ['./select-year-and-month.component.scss'],
})
export class SelectYearAndMonthComponent implements OnInit {

  isBusy: boolean;

  @Input()
  year: number;
  @Input()
  month: number;
  @Input()
  submitTittle: string;
  items: number[] = [1,2,3,4,5,6,7,8,9,10,11,12];

  constructor(
    private modalController: ModalController,
    private appStateService: AppStateService,
    public commonUtils: CommonUtils,

  ) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });

  }

  onClose() {
    if (!this.isBusy) {
      this.modalController.dismiss(null).then(() => {
      });
    }
  }

  onSubmit() {
    if(this.year  && this.month){
      this.modalController.dismiss({'month': this.month, 'year': this.year}).then(() => {
      });
    }
  }
}
